<template>
  <validation-observer ref="observer" v-slot="{ passes }">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ titulo }}
        </p>
      </header>
      <div class="modal-card-body">
        <section>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Código"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input
                v-model="model.id"
                type="text"
                :disabled="modificacion"
                @blur="inputUsernameHandle"
              />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Nombre Usuario"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input
                v-model="model.nombre"
                type="text"
                :disabled="nombreBloqueado"
              />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.estaDisponible" type="is-info">
                Está activo?
              </b-checkbox>
            </b-field>
          </validation-provider>
        </section>
        <validation-provider v-slot="{ errors, valid }" rules="required">
          <section>
            <label class="label">Roles</label>
            <b-field
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
              :custom-class="'checkbox-input'"
            >
              <b-checkbox
                v-for="(rol, index) in roles"
                :key="`rol-${index}`"
                v-model="model.roles"
                :native-value="{ id: rol.id }"
                type="is-info"
              >
                {{ rol.nombre }}
              </b-checkbox>
            </b-field>
          </section>
        </validation-provider>
      </div>
      <footer class="modal-card-foot">
        <div class="buttons">
          <b-button type="is-info" @click="passes(submit)">
            <span>Guardar</span>
          </b-button>
          <button class="button" @click="cerrarForm">
            <span>Salir</span>
          </button>
        </div>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

import { usuarioService } from '@/services'

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})

export default {
  name: 'UsuarioForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    titulo: {
      type: String,
      default: 'Agregar Registro'
    },
    modificacion: {
      type: Boolean,
      default: false
    },
    bodegaId: {
      type: Number,
      required: true
    },
    roles: {
      type: Array,
      default: () => []
    },
    objeto: {
      type: Object,
      required: false,
      default: () => ({
        id: null,
        nombre: null,
        estaDisponible: false,
        roles: []
      })
    }
  },
  data: () => ({
    model: {
      id: null,
      nombre: null,
      estaDisponible: false,
      roles: []
    },
    nombreBloqueado: false,
    cargando: false
  }),
  mounted() {
    this.modelo = Object.assign(this.model, this.objeto)
  },
  methods: {
    submit() {
      const self = this
      const model = Object.assign({}, this.model, { bodegaId: this.bodegaId })
      Promise.all([
        this.modificacion
          ? usuarioService.updateUsuario(self.objeto.id, model)
          : usuarioService.addUsuario(model)
      ])
        .then((_) => {
          self.notificarAccionCompletada(
            `Se ${
              this.modificacion ? 'modificó' : 'agregó'
            } usuario correctamente`
          )
          self.$emit('close', true)
        })
        .catch((error) => self.procesarError(error))
    },
    cerrarForm() {
      this.$emit('close', false)
    },
    async inputUsernameHandle(event) {
      this.nombreBloqueado = false
      this.model.nombre = ''
      const rs = await usuarioService.getUsuario(event.target.value)
      if (rs.status === 204) return
      this.model.nombre = rs.data.nombre
      this.nombreBloqueado = true
    }
  }
}
</script>
